<!--
	描述：通用的键值对录入方式弹窗
-->
<template>
	<dialogBody @confirm="confirm" @cancel="cancel" ref="body">
		<template slot="title">
			{{title}}
		</template>
		<input type="text" v-model="filterInfo" placeholder="按名称过滤" style="margin: 5px auto;width: 90%;display: block;">
		<multipleSelection ref="selectionBean" :dataList="showDataList" style="height: 350px;width: 498px;"
		 :defaultCheckedIds="defaultCheckedIds" :selectionType="selectionType" :getIdMethod="getIdMethod"></multipleSelection>
	</dialogBody>
</template>

<script>
	import dialogBody from './dialogBody.vue'
	import multipleSelection from '@/components/module/selection/base/multipleSelection.vue'
	export default {
		components: {
			dialogBody,
			multipleSelection
		},
		props: [],
		data() {
			return {
				dataList: [],
				title: '',
				getIdMethod: item => item.next == undefined ? item.id : 'group' + item.id,
				callback: undefined,
				cancelCallBack: undefined,
				selectionType: undefined,
				defaultCheckedIds: undefined,
				filterInfo: ''
			}
		},
		computed: {
			showDataList() {
				if (this.filterInfo != null && this.filterInfo.length > 0) {
					//需要过滤
					var list = filterTreeRecursive(copy(this.dataList), item => {
						if (item.hasOwnProperty('next')) {
							return true
						}
						if (item.name.includes(this.filterInfo)) {
							return true
						}
						return false
					})
					//再次过滤空数组
					list = filterTreeRecursive(list,item=>{
						if (item.hasOwnProperty('next') && item.next.length == 0) {
							return false
						}
						return true
					})
					// console.log("list",list);
					return list
				} else {
					//不需要过滤
										// console.log("this.dataList",this.dataList);
					return this.dataList
				}
			}
		},
		watch: {},
		mounted() {
			
		},
		methods: {
			confirm() {
				if (this.callback != undefined) {
					this.callback(this.$refs.selectionBean.getNowCheckList())
				}
				this.close()
			},
			cancel() {
				if (this.cancelCallBack != undefined) {
					this.cancelCallBack()
				}
				this.close()
			},
			setGetIdMethod(func) {
				this.getIdMethod = func
			},
			openDialog(title, dataList, defaultCheckedIds, callback, cancelcallback) {
				this.title = title
				this.dataList = dataList
				this.callback = callback
				this.cancelCallBack = cancelcallback
				this.defaultCheckedIds = defaultCheckedIds
				this.$refs.body.open()
			},
			openSingleItemDialog(title, dataList, defaultCheckedIds, callback, cancelcallback) {
				this.selectionType = 'singleItem'
				this.openDialog(title, dataList, defaultCheckedIds, callback, cancelcallback)
			},
			openSingleGroupDialog(title, dataList, defaultCheckedIds, callback, cancelcallback) {
				this.selectionType = 'singleGroup'
				this.openDialog(title, dataList, defaultCheckedIds, callback, cancelcallback)
			},
			openMultipleSelectionDialog(title, dataList, defaultCheckedIds, callback, cancelcallback) {
				this.selectionType = 'multiple'
				this.openDialog(title, dataList, defaultCheckedIds, callback, cancelcallback)
			},
			close() {
				this.$refs.body.hide()
				this.filterInfo = ''
				//重置id方法避免影响后面的使用
				this.getIdMethod = item => item.next == undefined ? item.id : 'group' + item.id
			},
		}
	}
</script>
<style scoped>
	>>>.msvalue {
		padding: 0;
		border: 0;
	}
</style>
